import React, { useRef, useState } from "react";
import { P_Props } from "./BlogForm.type";
import { Form, Field } from "react-final-form";
import { FormUtil, FormUIUtil, loadCallback, ImageUtil } from "../../../utils";
import {
  HtmlEditor,
  ImageUpload,
  Loading,
  SimpleModalHeader,
  Notification,
  Pulse,
  CategoryCard1,
} from "../../components";
import {
  Grid,
  TextField,
  Select,
  OutlinedInput,
  MenuItem,
  InputAdornment,
  Switch,
  FormControlLabel,
  Dialog,
  Chip,
} from "@material-ui/core";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { Event as EventIcon, PriorityHigh as PriorityHighIcon } from "@material-ui/icons";
import { BlogOutputModel, FORM_MODE } from "../../../models";
import { Autocomplete } from "@material-ui/lab";
import { ImageService } from "../../../services";

const BlogFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  let globalDirty: any;
  let slugify = require("slugify");
  const [visibleTextEditor, setVisibleTextEditor] = useState<boolean>(false);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState<boolean>(false);
  const [visibleSaveWarning, setVisibleSaveWarning] = React.useState<{
    visible: boolean;
  }>({ visible: false });
  const inputTagsRef = useRef<HTMLInputElement>();

  const toggleDeleteModal = () => {
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  const toggleSaveWarningModal = (visible: boolean, isChanged?: boolean) => {
    setVisibleSaveWarning({ visible: visible });
    globalDirty = isChanged;
  };

  const bindingBlogDataToForm = (data: BlogOutputModel[]) => {
    const tempData: (BlogOutputModel & {
      categoryBlogId: string[];
    })[] = data.map((e) => {
      const ids: string[] = e.categories.map((cate) => cate.categoryId);

      return { ...e, categoryBlogId: ids }; // categoryBlogId to form
    });

    const result = Object.assign(
      FormUtil.buildInitDataForm(tempData, [
        { key: "title" },
        { key: "categoryBlogId" },
        { key: "shortDescription" },
        { key: "titleSEO" },
        { key: "descriptionSEO" },
        { key: "link" }
      ]),
      {
        // authorId: data[0].authors[0].authorId,
        labels: data[0].labels.map((e) => e.labelInformation),
        qaIds:
          (data[0] as any).qas && (data[0] as any).qas.length > 0
            ? (data[0] as any).qas.map((q: any) => q.qaId || q.qaInformation?.id).filter(Boolean)
            : (data[0] as any).qaIds || [],
      },
    );
    return result;
  };

  return (
    <>
      <div className="blog-form">
        <SimpleModalHeader
          title={props.mode === FORM_MODE.CREATE ? "New Post" : "Edit Post"}
          onClose={() => {
            props.onCancel();
          }}
        />

        <div className="blog-form__divide">
          <div className="blog-form__language">
            <h1>Language</h1>

            {props.languageOptions.map((lang) => {
              return (
                <CategoryCard1
                  key={lang.id}
                  name={lang.name}
                  onClick={() => {
                    props.onChangeLanguage(lang.id);
                  }}
                  picture={lang.image}
                  selected={props.activeLang === lang.id}
                  buildPictureSrc={ImageUtil.buildLanguageImgSrc}
                  isAvatar={true}
                />
              );
            })}
          </div>
          <div className="blog-form__container">
            <div className="blog-form__box">
              {props.loading && <Loading />}
              {!props.loading && (
                <Form
                  initialValues={
                    props.initData
                      ? bindingBlogDataToForm(props.initData)
                      : {
                          labels: [],
                          // shortDescription: "",
                        }
                  }
                  initialValuesEqual={() => true}
                  onSubmit={async (values, form) => {
                    props.onSubmit(values);
                  }}
                  validate={(values) => {
                    const errors: any = {};

                    // if (props.blogStatus.status) {
                    //   {
                    //     props.languageOptions.map((lang) => {
                    //       errors[`title${lang.code}`] = FormUtil.Rule.required(
                    //         "Xin nhập tiêu đề bài viết"
                    //       )(values[`title${lang.code}`]);
                    //     });
                    //   }
                    // }

                    return errors;
                  }}
                  render={({ handleSubmit, form, pristine, errors, dirty }) => {
                    if (dirty && !visibleSaveWarning.visible && props.mode === FORM_MODE.EDIT) {
                      globalDirty = dirty;
                    }
                    submit = handleSubmit;

                    return (
                      <form onSubmit={handleSubmit}>
                        {props.languageOptions.map((lang) => {
                          return (
                            <div
                              key={lang.id}
                              style={{
                                display: props.activeLang === lang.id ? "flex" : "none",
                              }}
                            >
                              <Field
                                name={`title${lang.id}`}
                                validate={lang.isPrimary ? FormUtil.Rule.required("Please input title") : undefined}
                                subscription={{
                                  touched: true,
                                  error: true,
                                  value: true,
                                }}
                              >
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    `Title ${lang.name}`,
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Add title"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => {
                                        input.onChange(e.target.value);
                                        const slug: string = slugify(e.target.value ?? "", {
                                          replacement: "-", // replace spaces with replacement character, defaults to `-`
                                          lower: true, // convert to lower case, defaults to `false`
                                          strict: true, // strip special characters except replacement, defaults to `false`
                                        });
                                        form.change(`link${lang.id}`, slug);
                                      }}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />,
                                    false,
                                    true,
                                  );
                                }}
                              </Field>
                            </div>
                          );
                        })}

                        {props.languageOptions.map((lang) => {
                          return (
                            <div
                              key={lang.id}
                              style={{
                                display: props.activeLang === lang.id ? "flex" : "none",
                              }}
                            >
                              <Field name={`categoryBlogId${lang.id}`}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Category",
                                    <Select
                                      {...input}
                                      {...rest}
                                      // native
                                      multiple
                                      value={[...input.value]}
                                      error={meta.error && meta.touched}
                                      fullWidth
                                      input={<OutlinedInput className="form-text-field" />}
                                      variant="outlined"
                                      renderValue={(selected: any) => {
                                        const cates = props.categories
                                          .filter((cate) => selected.includes(cate.id))
                                          .map((cate) => {
                                            return (
                                              <Chip
                                                className="blog-form__box__select__chip"
                                                key={cate.code}
                                                label={cate.title}
                                              />
                                            );
                                          });
                                        return cates;
                                      }}
                                      className="form-select-field blog-form__box__select"
                                    >
                                      {props.categories.map((cate) => (
                                        <MenuItem key={cate.id} value={cate.id}>
                                          {cate.title}
                                        </MenuItem>
                                      ))}
                                    </Select>,
                                  );
                                }}
                              </Field>
                            </div>
                          );
                        })}
                        <Field name="labels">
                          {({ input, meta, ...rest }) => {
                            return FormUIUtil.renderFormItem(
                              "Label",
                              <Autocomplete
                                {...input}
                                {...rest}
                                onChange={(e, value) => {
                                  input.onChange(value);
                                }}
                                limitTags={5}
                                fullWidth
                                multiple
                                options={props.allLabels}
                                getOptionLabel={(option) => option.name}
                                getOptionSelected={(option, value) => option.id === value.id}
                                filterSelectedOptions
                                renderInput={(params) => {
                                  return (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      placeholder="Type and enter to create new label"
                                      onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                          e.preventDefault();
                                          props.onCreateTag(inputTagsRef.current?.value || "", {
                                            success: (data) => {
                                              input.onChange([...input.value, { name: data.name, id: data.id }]);
                                            },
                                          });
                                        }
                                      }}
                                      inputRef={inputTagsRef}
                                    />
                                  );
                                }}
                                className="form-autocomplete-select-field"
                              />,
                            );
                          }}
                        </Field>

                        <Grid item xs={12}>
                          <div>
                            <Field name={`qaIds`}>
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "FAQ",
                                  <Select
                                    {...input}
                                    {...rest}
                                    multiple
                                    value={input.value || []}
                                    renderValue={(selected) => (
                                      <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                                        {(selected as string[]).map((val) => {
                                          const faq = props.faqs.find((f) => f.id === val);
                                          return <Chip key={val} label={faq?.answer || val} size="small" />;
                                        })}
                                      </div>
                                    )}
                                    error={meta.error && meta.touched}
                                    fullWidth
                                    input={<OutlinedInput className="form-text-field" />}
                                    variant="outlined"
                                    className="form-select-field blog-form__box__select"
                                  >
                                    {props.faqs.map((faq) => (
                                      <MenuItem key={faq.id} value={faq.id}>
                                        {faq.answer}
                                      </MenuItem>
                                    ))}
                                  </Select>,
                                );
                              }}
                            </Field>
                          </div>
                        </Grid>

                        <Field name="author">
                          {({ input, meta, ...rest }) => {
                            return FormUIUtil.renderFormItem(
                              "Author",
                              <TextField
                                {...input}
                                {...rest}
                                fullWidth
                                placeholder="Add author"
                                className="form-textarea-field"
                                variant="outlined"
                                inputProps={{ className: "input" }}
                                onChange={(e) => input.onChange(e.target.value)}
                                helperText={meta.touched ? meta.error : ""}
                                error={meta.error && meta.touched}
                              />,
                            );
                          }}
                        </Field>

                        <Grid container spacing={6} justify="space-between">
                          <Grid item xs={12} md={6}>
                            {FormUIUtil.renderFormItem(
                              "Featured Image",
                              <ImageUpload
                                className="blog-form__avatar"
                                fileList={props.blogPictures}
                                max={1}
                                onChange={props.onUploadAvatar}
                                onDelete={props.onRemoveAvatar}
                                config={{ uploadModal: true }}
                              />,
                              false,
                              true,
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            {FormUIUtil.renderFormItem(
                              "Status",
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={props.blogStatus.status}
                                    onChange={(e) => {
                                      props.onChangeBlogStatus(e.target.checked);
                                    }}
                                    className="app-switch-box"
                                  />
                                }
                                label={
                                  <div className="form-label" style={{ marginBottom: 0 }}>
                                    Publish
                                  </div>
                                }
                              />,
                            )}
                            {FormUIUtil.renderFormItem(
                              "Publish Date",
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DateTimePicker
                                  ampm={false}
                                  inputVariant="outlined"
                                  value={props.blogStatus.timePublication}
                                  onChange={(value) => {
                                    if (value) {
                                      props.onChangeTimePublication(value.toISOString());
                                    }
                                  }}
                                  format="dd/MM/yyyy hh:mm a"
                                  className="form-text-field"
                                  fullWidth
                                  inputProps={{ className: "input" }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <EventIcon style={{ fontSize: "2.2rem" }} />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </MuiPickersUtilsProvider>,
                            )}
                          </Grid>
                        </Grid>
                        {props.languageOptions.map((lang) => {
                          return (
                            <div
                              key={lang.id}
                              style={{
                                display: props.activeLang === lang.id ? "flex" : "none",
                              }}
                            >
                              <Field
                                name={`shortDescription${lang.id}`}
                                subscription={{
                                  touched: true,
                                  error: true,
                                  value: true,
                                }}
                              >
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    `Short description`,
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      multiline
                                      rows={2}
                                      placeholder="Add short description"
                                      className="form-textarea-field"
                                      inputProps={{ className: "input", maxLength: 170 }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />,
                                  );
                                }}
                              </Field>
                            </div>
                          );
                        })}

                        <div
                          onClick={() => {
                            setVisibleTextEditor(true);
                          }}
                          style={{ color: "#6658F3", cursor: "pointer" }}
                          className="form-label"
                        >
                          More Detail
                        </div>

                        <div className="blog-form__seo">
                          <div className="blog-form__title">SEO</div>
                        </div>

                        {props.languageOptions.map((lang) => {
                          return (
                            <div
                              key={lang.id}
                              style={{
                                display: props.activeLang === lang.id ? "block" : "none",
                              }}
                            >
                              <Field name={`titleSEO${lang.id}`}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    <div>
                                      Meta title <span className="form-label__extra">Optional</span>
                                    </div>,
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Add page title"
                                      variant="outlined"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      onChange={(e) => input.onChange(e.target.value)}
                                    />,
                                  );
                                }}
                              </Field>

                              <Field name={`descriptionSEO${lang.id}`}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Meta description",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Enter meta description..."
                                      className="form-textarea-field"
                                      multiline
                                      rows={4}
                                      variant="outlined"
                                      inputProps={{ className: "input" }}
                                      onChange={(e) => input.onChange(e.target.value)}
                                    />,
                                  );
                                }}
                              </Field>

                              <Field name={`link${lang.id}`} validate={lang.isPrimary ? FormUtil.Rule.required("Please input url") : undefined}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "URL",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="url"
                                      variant="outlined"
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      onChange={(e) => {
                                        return input.onChange(
                                          slugify(e.target.value ?? "", {
                                            replacement: "-",
                                            lower: true,
                                            strict: true,
                                          }),
                                        );
                                      }}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />,
                                    false,
                                    true,
                                  );
                                }}
                              </Field>
                            </div>
                          );
                        })}
                      </form>
                    );
                  }}
                />
              )}
            </div>
          </div>
        </div>

        <div className="blog-form__footer">
          {props.mode !== FORM_MODE.CREATE && (
            <button
              className="btn delete"
              onClick={(e) => {
                e.preventDefault();
                toggleDeleteModal();
              }}
            >
              Delete
            </button>
          )}
          <button
            className="btn cancel"
            onClick={(e) => {
              e.preventDefault();
              globalDirty && props.mode === FORM_MODE.EDIT
                ? toggleSaveWarningModal(true, globalDirty)
                : props.onCancel();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn save"
            onClick={(e) => {
              loadCallback(submit, e);
            }}
          >
            Save
          </button>
        </div>
      </div>

      <Dialog
        maxWidth="lg"
        fullWidth
        className="blog-form__editor"
        open={visibleTextEditor}
        onClose={() => {
          setVisibleTextEditor(false);
        }}
      >
        {props.languageOptions.map((lang) => {
          return (
            <div
              key={lang.id}
              style={{
                display: props.activeLang === lang.id ? "unset" : "none",
              }}
            >
              <HtmlEditor
                key={lang.id}
                initValue={props.newBlogContent[lang.id]}
                imageHandler={props.onUploadContentImgHandler}
                onSave={(val) => {
                  setVisibleTextEditor(false);
                  if (props.newBlogContent[lang.id] !== val) {
                    props.onChangeBlogContent(val, lang.id);
                  }
                }}
                onCancel={() => setVisibleTextEditor(false)}
                onUploadImg={ImageService.uploadBlogImage}
                buildImgSrc={ImageUtil.buildBlogImgSrc}
              />
            </div>
          );
        })}
      </Dialog>

      <Notification
        visible={visibleDeleteModal}
        title="Delete post"
        subTitle="Are you sure you want to delete this post?"
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="blog-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteModal();
              }}
            >
              Cancel
            </button>
            <button
              className="blog-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteModal();
                props.onDeleteBlog();
              }}
            >
              Confirm
            </button>
          </>
        }
      />

      <Notification
        visible={visibleSaveWarning.visible}
        title={"Warning Leave"}
        subTitle={`You haven't saved your changes. Are you sure you want leave?`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="blog-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleSaveWarningModal(false, true);
              }}
            >
              Cancel
            </button>
            <button
              className="blog-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleSaveWarningModal(false);
                props.onCancel();
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default BlogFormPresenter;
